// import { globalPut } from '../index';
import { post } from "../index";

export const uploadRevisionCsv = body => {
  return post('/revision/csv', body, true);
}
